// Country to region mapping
export const countryToRegion: Record<string, string> = {
  // Asia
  'China': 'asia',
  'India': 'asia',
  'Japan': 'asia',
  'South Korea': 'asia',
  'Indonesia': 'asia',
  'Thailand': 'asia',
  'Vietnam': 'asia',
  'Malaysia': 'asia',
  'Philippines': 'asia',
  'Bangladesh': 'asia',
  'Pakistan': 'asia',
  'Nepal': 'asia',
  'Kazakhstan': 'asia',
  'United Arab Emirates': 'asia',
  'Israel': 'asia',
  'Iran': 'asia',
  'Iraq': 'asia',
  'Jordan': 'asia',
  'Lebanon': 'asia',
  'Turkey': 'asia',
  'Mongolia': 'asia',
  
  // Europe
  'Russia': 'europe',
  'Germany': 'europe',
  'United Kingdom': 'europe',
  'France': 'europe',
  'Italy': 'europe',
  'Spain': 'europe',
  'Poland': 'europe',
  'Romania': 'europe',
  'Netherlands': 'europe',
  'Belgium': 'europe',
  'Czech Republic': 'europe',
  'Greece': 'europe',
  'Portugal': 'europe',
  'Sweden': 'europe',
  'Hungary': 'europe',
  'Austria': 'europe',
  'Belarus': 'europe',
  'Switzerland': 'europe',
  'Bulgaria': 'europe',
  'Serbia': 'europe',
  'Denmark': 'europe',
  'Finland': 'europe',
  'Slovakia': 'europe',
  'Norway': 'europe',
  'Ireland': 'europe',
  'Croatia': 'europe',
  'Lithuania': 'europe',
  'Slovenia': 'europe',
  'Latvia': 'europe',
  'Estonia': 'europe',
  'Cyprus': 'europe',
  'Ukraine': 'europe',
  
  // North America
  'United States': 'north-america',
  'Canada': 'north-america',
  'Mexico': 'north-america',
  'Guatemala': 'north-america',
  'Cuba': 'north-america',
  'Dominican Republic': 'north-america',
  'Panama': 'north-america',
  'Costa Rica': 'north-america',
  
  // South America
  'Brazil': 'south-america',
  'Argentina': 'south-america',
  'Colombia': 'south-america',
  'Peru': 'south-america',
  'Chile': 'south-america',
  'Bolivia': 'south-america',
  'Paraguay': 'south-america',
  'Uruguay': 'south-america',
  
  // Africa
  'South Africa': 'africa',
  'Morocco': 'africa',
  'Tunisia': 'africa',
  'Egypt': 'africa',
  'Nigeria': 'africa',
  'Kenya': 'africa',
  'Ghana': 'africa',
  'Ethiopia': 'africa',
  
  // Oceania
  'Australia': 'oceania',
  'New Zealand': 'oceania',
  'Fiji': 'oceania',
}; 